import { useLocSettings } from "../../hooks/SettingsHooks";
import { useSpecsTranslation } from "../../hooks/TranslationHooks";
import Checkbox from "../Checkbox";
import IconWithPopup from "../IconWithPopup";

const ProductsFiltersItem = ({
  field,
  value,
  unit,
  count,
  totalCount,
  activeFilters,
  setFilter
}) => {
  const settings = useLocSettings();
  const ts = useSpecsTranslation();

  const icon = settings.specifications?.[field]?.icons?.[value];
  const isActive = (field, value) =>
    activeFilters[field] && activeFilters[field].includes(value);
  const toggleFilter = (field, value) => {
    setFilter(field, value, !isActive(field, value));
  };
  const valueDescription =
    settings.specifications?.[field]?.value_descriptions?.[value]?.description;

  const checked = isActive(field, value);
  return (
    <li
      role="option"
      aria-selected={checked}
      tabIndex="0"
      className={"filter-line"}
      onClick={() => toggleFilter(field, value)}
      onKeyDown={e => {
        switch (e.key) {
          case "Enter":
          case "Space":
            e.preventDefault();
            e.stopPropagation();
            toggleFilter(field, value);
            break;
          default:
        }
      }}
      data-field={field}
      data-value={value}
      data-checked={!!checked}
    >
      <Checkbox checked={checked} fillColor="#fff" />
      <div className={"filter-text"}>
        {icon ? (
          <IconWithPopup
            field={field}
            value={value}
            unit={unit}
            showLabel
            noTooltip={!valueDescription}
          />
        ) : (
          <span>{ts(field, value)}</span>
        )}
      </div>
      <div className={"filter-count"}>
        <span>{count}</span>{" "}
        <span className={"filter-count-total"}>
          <span>(</span>
          <span>{totalCount}</span>
          <span>)</span>
        </span>
      </div>
    </li>
  );
};

export default ProductsFiltersItem;
